import { render, staticRenderFns } from "./cAttention.vue?vue&type=template&id=b1f66fd2&scoped=true"
import script from "./cAttention.vue?vue&type=script&lang=js"
export * from "./cAttention.vue?vue&type=script&lang=js"
import style0 from "./cAttention.vue?vue&type=style&index=0&id=b1f66fd2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f66fd2",
  null
  
)

export default component.exports